import {Component, Input} from '@angular/core';
import {LoadingController, NavController, NavParams} from 'ionic-angular';
import {Globals} from "../../../../globals";

/**
 * Generated class for the ProductViewListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-delibery-note-view-list',
    templateUrl: 'delibery-note-view-list.html',
})
export class DeliberyNoteViewListPage {
    @Input() proding: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public loadingCtrl: LoadingController,
                public globals: Globals) {
    }

    /*edit(){
        this.navCtrl.push(DeliberyNoteCreateSelectIngprodPage, {
            update_state: true,
            delibery_note_uid: this.proding.UID,
            prodings: this.proding,
        });

    }*/

}



// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-view/delibery-note-view-list/delibery-note-view-list.ts